module.exports = __webpack_public_path__ + "static/media/step-info-es.419a5a45.png";